import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Async
import reservationRequestsAsync from "./reservationRequestsAsync";

interface IState {
  ids: number[] | null;
  entities: any;
  total: number;
  isCreatedUser: boolean;
}

const initialState:IState = {
  ids: null,
  entities: {},
  total: 0,
  isCreatedUser: false,
};

const reservationRequestsSlice = createSlice({
  name: 'reservationRequests',
  initialState,
  reducers: {
    setIsCreatedUser: (state, action:PayloadAction<boolean>) => {
      state.isCreatedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch reservation requests
      .addCase(reservationRequestsAsync.fetchReservationRequests.pending, (state) => {
        state.ids = null;
        state.entities = {};
      })
      .addCase(reservationRequestsAsync.fetchReservationRequests.fulfilled, (state, action:PayloadAction<any>) => {
        if (action.payload.data) {
          const entities = action.payload.data.reduce((acc:{ [key:number]:any }, cur:any) => {
            acc[cur.id] = cur;
            return acc;
          }, {});
          state.ids = Object.keys(entities).map(Number);
          state.entities = entities;
        }
        state.total = action.payload.total;
      })
  }
});

export const reservationRequestsActions = reservationRequestsSlice.actions;

export default reservationRequestsSlice.reducer;
